//TODO: Hook up "My Courses" when ready + update tests
import React, { useState } from 'react';
import { useRouter } from 'next/router';
import FeaturebaseWidget from '../../shared/FeaturebaseWidget';
import { LightbulbIconOutline } from '../../../modules/Icons';

import { AcademyLeftNavBarProps } from '../../../types/components/academy/sidebarNav/LeftNavBarFilters';

import { TopLevelLink } from '../../leftNavBar/TopLevelLink';
import AcademyTopLevelLinkConfig from './constants/AcademyTopLevelLinkContent';
import { DividerWithoutText } from '../../../modules/DividerWithText';
import FiltersList from './FiltersList';
import MobileNav from './MobileNav';

export const containerStyle = "md:block bg-a-dark-gray"
export const innerContainerStyle = "block w-full md:w-[292px] bg-a-dark-gray text-white-60 py-6 px-4 relative h-full"

export const dividerStyle = "w-1/2 !border-white !border-opacity-[12%] border-1"

export const requestProductStyle =
  'flex items-center px-4 cursor-pointer leading-[48px] text-[15px] text-white stroke-[#7F898D] hover:text-a-blue hover:stroke-a-blue h-[40px]';

const AcademyLeftNavBar: React.FC<AcademyLeftNavBarProps> = (props) => {
  const { selectedFilters, setSelectedFilters, filtersDisabled } = props;
  const [showSidebar, setShowSidebar] = useState<boolean>(false);
  const [showScroll, setShowScroll] = useState<boolean>(false);

  const router = useRouter();
  const currentPath = router.asPath;


  const isRouteActive = (route: string): boolean => {
    const cleanPath = currentPath.split('?')[0].split('#')[0];

    if (route === '/academy') {
      return cleanPath === '/academy' || cleanPath === '/academy/';
    }

    return cleanPath === route ||
      (cleanPath.startsWith(route + '/') && route !== '/');
  };

  const renderNavigationLinks = () => (
    <>
      {AcademyTopLevelLinkConfig.map((item, index) => {
        const isSelected = isRouteActive(item.href);
        const iconComponent = isSelected && item.selectedIcon ? item.selectedIcon : item.icon;
        return (
            <TopLevelLink
              key={`top-level-link-${index}`}
              href={item.href}
              icon={iconComponent}
              text={item.text}
              selected={isSelected}
            />
        );
      })}

      <DividerWithoutText dividerLineStyle={dividerStyle} />

      {/* COMING SOON! */}
      {/* <TopLevelLink
        href="/academy/my-courses"
        icon={<MyCoursesIcon className={iconStyle} />}
        text="My Courses"
        selected={isRouteActive('/academy/my-courses')}
      /> */}

    </>
  );

  const getCurrentCategory = (): string => {
    let category = "All Collections";

    if (isRouteActive('/academy/my-courses')) {
      return "My Courses";
    }

    for (const item of AcademyTopLevelLinkConfig) {
      if (isRouteActive(item.href)) {
        return item.text;
      }
    }

    return category;
  };

  return (
    <>
      <MobileNav
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        category={getCurrentCategory()}
      />

      <div cy-test-id="academy-sidebar-nav" className={`${showSidebar ? 'block' : 'hidden'} ${containerStyle}`}>
        <div
          onMouseEnter={() => setShowScroll(true)}
          className={innerContainerStyle}
        >
          {renderNavigationLinks()}
          <FiltersList
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            showScroll={showScroll}
            disabled={filtersDisabled}
          />
          <DividerWithoutText dividerLineStyle={dividerStyle} />
          <FeaturebaseWidget board="Academy Feedback">
            <div>
              <button
                data-featurebase-feedback
                className={requestProductStyle}>
                <LightbulbIconOutline className="inline w-4 mr-4 stroke-inherit fill-inherit" />
                Request a Product
              </button>
            </div>
          </FeaturebaseWidget>

        </div>
      </div>
    </>
  );
};

export default AcademyLeftNavBar;
